/**
 * Clean WordPress HTML artifacts from content
 * Removes WordPress block editor comments and other artifacts
 */
export function cleanWordPressHtml(html: string | null | undefined): string {
    if (!html) return '';

    let cleaned = html;

    // Remove WordPress block editor comments (<!-- wp:paragraph --> etc)
    cleaned = cleaned.replace(/<!--\s*\/?wp:[^>]*-->/g, '');

    // Remove WordPress audio shortcodes (the file is shown via the attachment player)
    cleaned = cleaned.replace(
        /\[audio\b[^\]]*\](?:[\s\S]*?\[\/audio\])?/gi,
        ''
    );

    // Drop the type attribute from <source> tags. WordPress often declares a wrong
    // MIME (e.g. an .m4a/AAC file marked audio/mpeg); iOS Safari trusts that type,
    // fails to decode, and the media never plays. Without it the browser falls back
    // to the server's Content-Type, which is correct.
    cleaned = cleaned.replace(
        /(<source\b[^>]*?)\s+type=(["'])[^"']*\2/gi,
        '$1'
    );

    // Remove empty paragraphs
    cleaned = cleaned.replace(/<p>\s*<\/p>/g, '');

    // Remove multiple consecutive spaces
    cleaned = cleaned.replace(/\s+/g, ' ');

    // Trim whitespace
    cleaned = cleaned.trim();

    return cleaned;
}
